export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/environments/environment.ts